import { motion } from "motion/react";

const headingVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.15 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

const viewportConfig = { once: true, amount: 0.2 };

export default function AboutMe() {
  return (
    <section className="portfolio--section" id="AboutMe">
      <div className="portfolio--container-box">
        <motion.div
          className="portfolio--container"
          variants={headingVariants}
          initial="hidden"
          whileInView="show"
          viewport={viewportConfig}
        >
          <h2 className="section--heading">Professional Interests</h2>
        </motion.div>
      </div>
      <motion.div
        className="portfolio--section--container"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={viewportConfig}
      >
        <motion.div className="portfolio--section--card" variants={cardVariants}>
          <div className="portfolio--section--card--content">
            <div>
              <h3 className="portfolio--section--title">Software Development</h3>
              <p className="text-md">
                <strong>Enterprise Full-Stack Development (Accenture):</strong> Architecting mission-critical applications for Fortune 500 financial services clients, specializing in cloud-native microservices architecture using Node.js, React.js, Java, MongoDB, and Apache Kafka. Delivering scalable solutions within Accenture's patented Mercury Composable Framework that significantly reduce development cycles while serving millions of users.
              </p>
              <br />
              <p className="text-md">
                <strong>Cloud & Infrastructure Engineering (Accenture):</strong> Leading enterprise-scale cloud migrations and platform modernizations on AWS, achieving exceptional uptime and performance. Architecting automated CI/CD pipelines that dramatically reduce deployment time while implementing robust security controls and compliance frameworks for major financial institutions.
              </p>
              <br />
              <p className="text-md">
                <strong>Innovation & Emerging Technologies (Accenture):</strong> Delivering blockchain infrastructure solutions and enterprise data platforms integrating cutting-edge technologies. Contributing to successful Fortune 500 client acquisitions through technical excellence and innovative architectural solutions.
              </p>
              <br />
              <p className="text-md" style={{ fontStyle: 'italic', color: '#666' }}>
                <strong>Interested in learning more?</strong> Detailed project information and quantifiable achievements available upon request for serious opportunities.
              </p>
            </div>
          </div>
        </motion.div>
        <motion.div className="portfolio--section--card" variants={cardVariants}>
          <div className="portfolio--section--card--content">
            <div>
              <h3 className="portfolio--section--title">Entrepreneurship</h3>
              <p className="text-md">Founder of WyzeLab LLC, a strategic consulting firm empowering businesses to accelerate growth through AI and cloud transformation. Drawing from entrepreneurial experience with previous ventures, I partner with organizations to drive innovation and deliver measurable business outcomes. Learn more <a href="https://wyzelab.com" target="_blank" rel="noopener noreferrer">here</a>.</p>
            </div>
          </div>
        </motion.div>
        <motion.div className="portfolio--section--card" variants={cardVariants}>
          <div className="portfolio--section--card--content">
            <div>
              <h3 className="portfolio--section--title">Personal Development</h3>
              <p className="text-md">Continuously advancing expertise through AI innovation projects while staying at the forefront of emerging technologies. Currently developing an initiative to democratize financial literacy education, combining technical skills with a passion for creating accessible learning solutions that empower communities.</p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
